/**
 * Class description
 *
 * Created: 2016-08-17
 * @author jonas
 */
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Oktoberfest} from "../Oktoberfest";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";
import {OktoberfestGameConfig} from "../OktoberfestGameConfig";
import {TweenLite} from "gsap";
import {MathHelper} from "../../core/utils/MathHelper";
import {GameHelper} from "../../core/utils/GameHelper";


export class OktoberfestFreespinsLeftIndicatorView extends PIXI.Container {
    static BEER_IMAGE = "beer";
    static BEER_GLASS_IMAGE = "beerGlass";
    static BEER_LIQUID_ANIMATION = "beerLiquid";
    static LEVEL_UPDATE_ANIMATION_DURATION: number = 1;
    private static BEER_GLASS_X_OFFSET: number = 925;
    private static POSITION_Y: number = 197;
    private _liquidMovieClip: TimelineSprite;
    private _beer: PIXI.Sprite;
    private _beerGlass: PIXI.Sprite;
    private _beerContainer: PIXI.Container;

    private _freespinsLeft: number;
    private _isFreespin: boolean;
    private _freespinsWon: number;
    private _freespinIntroPanningXTween: TweenLite;

    constructor() {
        super();
        this.init();
    }

    //Only on desktop
    public onFreespinIntroViewClosed(): void {
        if (this._freespinIntroPanningXTween) {
            this._freespinIntroPanningXTween.kill();
        }
    }
    public onRestoreInFS():void{
        if (Oktoberfest.model.parsedInitData.isRestoreState) {
            this._freespinsWon = Oktoberfest.model.parsedInitData.addedNumberOfFreespinsThisSpin;
            this._freespinsLeft = Oktoberfest.model.parsedInitData.freespinsLeft;
            this.position.x = OktoberfestFreespinsLeftIndicatorView.BEER_GLASS_X_OFFSET;
            this._isFreespin = this._freespinsLeft > 0;
            if (GameHelper.isDesktop()) {
                this.visible = true;
            }
            this.y = OktoberfestFreespinsLeftIndicatorView.POSITION_Y;
        }
    }
    public onBeerGlassIntroPanning(duration: number): void {
        if (Oktoberfest.model.parsedInitData.isRestoreState) {
            this._freespinsWon = Oktoberfest.model.parsedInitData.addedNumberOfFreespinsThisSpin;
            this._freespinsLeft = Oktoberfest.model.parsedInitData.freespinsLeft;
        } else {
            this._freespinsWon = Oktoberfest.model.parsedGameData.addedNumberOfFreespinsThisSpin;
            this._freespinsLeft = Oktoberfest.model.parsedGameData.freespinsLeft;
        }

        this._isFreespin = this._freespinsLeft > 0;

        if (GameHelper.isDesktop()) {
            this.visible = true;
            this.x = OktoberfestFreespinsLeftIndicatorView.BEER_GLASS_X_OFFSET+133;
            this._freespinIntroPanningXTween = TweenLite.to(this, duration, {
                x: ( OktoberfestFreespinsLeftIndicatorView.BEER_GLASS_X_OFFSET ),
                ease: OktoberfestGameConfig.TIMING_FREESPIN_INTRO_PANNING_EASE
            });
        }
        this.y = OktoberfestFreespinsLeftIndicatorView.POSITION_Y;
    }

    public onGameReady(): void {
        const scale: number = NolimitApplication.screenBounds.scale;
        if (this._freespinIntroPanningXTween && this._freespinIntroPanningXTween.isActive()) {
            this._freespinIntroPanningXTween.kill();
        }
        this.position.x = OktoberfestFreespinsLeftIndicatorView.BEER_GLASS_X_OFFSET + 81;
        if (this._isFreespin) {
            this.setLevel(this._freespinsLeft, false);
        } else {
            this.onReset();
        }
        if (!GameHelper.isDesktop()) {
            this.visible = false;
        }
    }

    public onSpinStart(): void {
        if (Oktoberfest.model.isRestore) {
            this._isFreespin = Oktoberfest.model.parsedInitData.freespinsLeft > 0;
        } else {

            this._isFreespin = Oktoberfest.model.parsedGameData! && Oktoberfest.model.parsedGameData!.freespinsLeft > 0;
            if (Oktoberfest.model.parsedGameData) {
                this._freespinsLeft = Oktoberfest.model.parsedGameData.freespinsLeft;
            }
        }
        if (this._isFreespin) {
            this.setLevel(this._freespinsLeft - 1);
        }
    }

    public onReset(): void {
        this.setLevel(10, false);
        this.visible = false;
        this.position.y = ( OktoberfestFreespinsLeftIndicatorView.POSITION_Y );
    }

    public onFreespinsLeftUpdated(value: number): void {
        this.setLevel(value);
    }

    private init(): void {
        OktoberfestLayers.getLayer(Layers.BEER_LAYER)!.addChild(this);
        this.initAnimations();
    }

    private initAnimations(): void {
        this.createBeerGlass();
        Oktoberfest.scatterMeter.onMultiplierAnimationCreated(OktoberfestFreespinsLeftIndicatorView.LEVEL_UPDATE_ANIMATION_DURATION);
        Oktoberfest.scatterMeter.onFreespinLeftAnimationCreated(OktoberfestFreespinsLeftIndicatorView.LEVEL_UPDATE_ANIMATION_DURATION);
    }

    private createBeerGlass(): void {
        this._beerGlass = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures(OktoberfestFreespinsLeftIndicatorView.BEER_GLASS_IMAGE)[0]);
        this._beerGlass.anchor.set(0, 0);
        this._beerContainer = new PIXI.Container();
        this._beerContainer.position.set(this._beerGlass.width * 0.5, 110 * 0.66);

        let beerMaskPolygon: number[] = [11, -250, 16, -424, 16, -431, 13, -435, 13, -441, 15, -444, 25, -447, 51, -450, 133, -452, 204, -448, 218, -445, 222, -442, 222, -434, 219, -431, 219, -424, 221, -383, 227, -87, 232, -83, 234, -77, 235, -40, 233, -36, 216, -22, 192, -11, 159, -3, 127, 0, 92, -1, 65, -5, 40, -12, 14, -25, 2, -36, 0, -42, 2, -81, 8, -87, 11, -205];
        let maskShape: PIXI.Graphics = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawPolygon(beerMaskPolygon);
        maskShape.endFill();
        maskShape.position.set(0, 259);//, OktoberfestGameConfig.convertYPos(452));
        this.addChild(maskShape);
        this._beerContainer.mask = maskShape;
        this.addChild(this._beerContainer);
        this.addChild(this._beerGlass);

        this._beer = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures(OktoberfestFreespinsLeftIndicatorView.BEER_IMAGE)[0]);
        this._beer.anchor.set(0.5, 0);
        this._beer.position.set(0, -40);
        this._beerContainer.addChild(this._beer);

        this._liquidMovieClip = new TimelineSprite(Oktoberfest.assetLoader.getTextures(OktoberfestFreespinsLeftIndicatorView.BEER_LIQUID_ANIMATION));
        this._liquidMovieClip.anchor.set(0.5, 0.5);
        this._liquidMovieClip.position.set(0, 0);
        this._beerContainer.addChild(this._liquidMovieClip);

        this.scale.set(2, 2); //Compensation for smaller assets.
    }

    private playLiquidAnimation(): void {
        this._liquidMovieClip.getAnimation([0]).timeScale(0.5);
    }

    private setLevel(freespinTotal: number, animated: boolean = true): void {
        this.visible = true;

        let minPos: number = 62;
        let maxPos: number = 253;
        let steps: number = Math.max(0, 10 - freespinTotal);
        let targetPositionY: number = MathHelper.map(steps, 0, 10, minPos, maxPos);
        if (animated) {
            this.playLiquidAnimation();
        }
        if (this._beerContainer.position.y != targetPositionY) {
            TweenLite.to(this._beerContainer, animated ? OktoberfestFreespinsLeftIndicatorView.LEVEL_UPDATE_ANIMATION_DURATION : 0,
                {y: targetPositionY}
            );
        }
        if (!GameHelper.isDesktop()) {
            this.visible = false;
        }
    }
}
